import React from 'react';
import { sanitizeText } from '../utils/sanitize';

interface SafeTextProps {
  children: string | undefined | null;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
}

/**
 * SafeText component that automatically sanitizes text content
 * to prevent XSS attacks from data stored in the database.
 *
 * Usage:
 *   <SafeText>{learner.fullname}</SafeText>
 *   <SafeText as="span" className="text-sm">{learner.email}</SafeText>
 */
export const SafeText: React.FC<SafeTextProps> = ({
  children,
  className,
  as: Component = 'span'
}) => {
  const sanitized = sanitizeText(children);

  return <Component className={className}>{sanitized}</Component>;
};

/**
 * Helper function to sanitize text inline without a component
 * Use this when you need to sanitize within an existing element
 */
export const safeText = (text: string | undefined | null): string => {
  return sanitizeText(text);
};

export default SafeText;
